import { render, staticRenderFns } from "./SquaresBoard.vue?vue&type=template&id=da282c94&"
import script from "./SquaresBoard.vue?vue&type=script&lang=js&"
export * from "./SquaresBoard.vue?vue&type=script&lang=js&"
import style0 from "./SquaresBoard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports